module.exports = __webpack_public_path__ + "static/media/e3.27b77016.png";